import queryString from 'query-string'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import authenticationAPI from 'api/authentication'
import SetPassword from 'components/authentication/form-fields/SetPassword'
import passwordOutcome from 'components/authentication/passwordOutcome'
import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

const EXPIRED_CODE_MSG = 'The provided reset code is invalid or expired'

export const ResetPassword: React.FC = () => {
  const resetPassword = authenticationAPI.resetPassword

  const navigate = useNavigate()
  const location = useLocation()

  const { code, email: defaultEmail } = queryString.parse(location.search)

  const [email, setEmail] = useState(defaultEmail)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (event) => {
    switch (event.target.name) {
      case 'email':
        setEmail(event.target.value)
        break

      case 'password':
        setPassword(event.target.value)
        break

      case 'confirmPassword':
        setConfirmPassword(event.target.value)
        break
    }
  }

  const handleSubmit = async (event) => {
    if (isSubmitting) {
      return
    }

    event.preventDefault()
    setIsSubmitting(true)

    try {
      await resetPassword(code, email, password)

      toast({
        type: 'success',
        text: 'Password reset successfully.'
      })

      setIsSubmitting(false)
      navigate('/')
    } catch (err) {
      const message = messageFromResponseError(
        err,
        'Unable to reset password. Please try again later.'
      )
      toast({
        type: 'error',
        text: message
      })

      setIsSubmitting(false)
      if (message === EXPIRED_CODE_MSG) {
        navigate('/')
        return
      }
    }
  }

  return (
    <SignedOutFormContainer>
      <SignedOutForm title="Reset your Password" onSubmit={handleSubmit}>
        <SetPassword
          confirmPassword={confirmPassword}
          handleChange={handleChange}
          hideAcceptPrivacyPolicy={true}
          isLoading={isSubmitting}
          password={password}
          passwordOutcome={passwordOutcome}
          submitLabel="Submit Password Reset"
        />
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}
